<template>
  <div>
    <el-dialog :title="$t('text.exportBankCardPayoutExcel')"
               :visible="isShowExportBankCardPayoutOrderDialog"
               width="30%"
               @close="handleDialog"
               :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item :label="$t('text.bankName')"
                      prop="bankCode">
          <el-select v-model="form.bankCode"
                     filterable
                     :placeholder="$t('message.chooseOne')">
            <el-option :key="bankCode"
                       v-for="{ bankName, bankCode } in bankList"
                       :label="bankName"
                       :value="bankCode"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.channelName')"
                      prop="channelId">
          <el-select v-model="form.channelId"
                     filterable
                     :placeholder="$t('message.chooseOne')">
            <el-option :key="channelId"
                       v-for="{ channelName, channelId } in channelList"
                       :label="channelName"
                       :value="channelId"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('text.export') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "ExportBankCardPayoutOrderDialog",
  props: {
    isShowExportBankCardPayoutOrderDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bankList: [],
      channelList: [],
      form: {
        bankCode: "",
        channelId: ""
      }
    };
  },
  methods: {
    handleDialog() {
      this.$refs["form"].resetFields();
      this.form = {
        bankCode: ""
      };
      this.$emit("update:isShowExportBankCardPayoutOrderDialog", false);
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.axios
              .get("/order/exportBankCardPayoutOrder", {
                params: this.form,
                responseType: "blob",
                timeout: 30 * 60 * 1000
              })
              .then((res) => {
                if (res.data) {
                  // 回excel資料，瀏覽器下載
                  const url = window.URL.createObjectURL(new Blob([res.data]));
                  const link = document.createElement("a");
                  link.href = url;
                  link.setAttribute("download", this.$t('text.disbursementOrders.xlsx'));
                  document.body.appendChild(link);
                  link.click();
                } else if (res.text) {
                  // 回JSON，開彈窗
                  res
                      .text()
                      .then(JSON.parse)
                      .then((res) => {
                        if (res.code !== 200) {
                          this.$message({
                            message: res.msg,
                            type: "error"
                          });
                        } else {
                          this.$message({
                            message: res.msg,
                            type: "success"
                          });
                        }
                      });
                }
                this.exporting = false;
              }).catch((error) => {
            console.log(error);
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: this.$t('message.exportFailed')
            });
            this.exporting = false;
          });
        }
      });
    }
  },
  created() {
    this.$axios
        .get("/order/selectPayoutBankList", {params: {}})
        .then((res) => {
          this.bankList = res.data;
        });
    this.$axios
        .get("/routeChannelInfo/selectByCondition", {params: {}})
        .then((res) => {
          res.data.map((item) => {
            if (item.productId === '120' && item.upstream === 'bank_to_bank') {
              this.channelList.push(item);
            }
          });
        });
  }
};
</script>
